import { IJsonFormatSettings, ParseFormat, ParseTransformation } from 'app/model/dataflow/parsetransformation';
import { Transformation } from 'app/model/dataflow/transformation';
import { ParsePlainObject } from 'worker/app-workers/shared/plainObjects/parse.plainObject';
import { DataFlowAdapterUtils } from '../../adapter.util';
import { DataFlowExpressionUtils } from '../../expression.util';
import { SchemaModifierBaseConvertor } from './schemaModifierBase.convertor';
import { IResourceContext } from 'shell-models-lib';

export class ParseConvertor extends SchemaModifierBaseConvertor {
    private get parseTransformation(): ParseTransformation {
        return this.transformation as ParseTransformation;
    }

    private get parseObject(): ParsePlainObject {
        return this.transformObject as ParsePlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        if (this.parseObject.configs.has('format')) {
            this._handledConfigs.push('format');
            this.parseTransformation.format = DataFlowExpressionUtils.extractStringConfigValue(
                this.parseObject.configs.get('format')
            ) as ParseFormat;
            const formatSettings =
                this.parseTransformation.format === ParseFormat.json
                    ? this.parseTransformation.jsonSettings
                    : this.parseTransformation.format === ParseFormat.delimitedText
                    ? this.parseTransformation.delimitedTextSettings
                    : this.parseTransformation.xmlSettings;
            this.parseObject.configs.forEach((expression: string, configName: string) => {
                if (configName === 'documentForm') {
                    (formatSettings as IJsonFormatSettings).documentForm =
                        DataFlowExpressionUtils.unwrapExpressionConfigValue(expression, this.parseTransformation);
                } else if (
                    configName !== 'format' &&
                    configName !== 'columnNamesAsHeader' &&
                    configName !== 'namespacePrefixes' &&
                    configName !== 'namespaces'
                ) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (formatSettings as any)[configName] = DataFlowExpressionUtils.extractStringConfigValue(expression);
                    this._handledConfigs.push(configName);
                } else if (configName === 'columnNamesAsHeader' || configName === 'namespaces') {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (formatSettings as any)[configName] =
                        DataFlowExpressionUtils.extractStringConfigValue(expression) === 'true';
                    this._handledConfigs.push(configName);
                } else if (configName === 'namespacePrefixes') {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (formatSettings as any)[configName] = expression
                        .slice(1, expression.length - 1)
                        .split(DataFlowAdapterUtils.MAP_ARRAY_SPLITTER)
                        .map((element) => {
                            const splits = element.split(DataFlowAdapterUtils.MAP_KEY_VALUE_SPLITTER);
                            return {
                                key: DataFlowExpressionUtils.extractStringConfigValue(splits[0].trim()),
                                val: DataFlowExpressionUtils.extractStringConfigValue(splits[1].trim())
                            };
                        });
                    this._handledConfigs.push(configName);
                }
            });
        }
        await super.convert(contextData);
        return this.transformation;
    }
}
